import React from 'react';
import { NextPage } from 'next';
import { getOrCreateStore } from '../../stores';
import SurfCams from '../../containers/SurfCams';

import { WavetrakContext } from '../../types/wavetrak';
import { AppPageProps } from '../_app';

const SurfCamsPage: NextPage<{}, AppPageProps> = () => <SurfCams />;

SurfCamsPage.getInitialProps = async (context: WavetrakContext) => {
  const store = getOrCreateStore();
  const { req } = context;
  const isServer = !!req;

  if (isServer) {
    return {
      enableCssBaseline: true,
      enableTheme: true,
      isFooterVisible: false,
      ssrReduxState: store.getState(),
    };
  }

  return {
    enableCssBaseline: true,
    enableTheme: true,
    isFooterVisible: false,
  };
};

export default SurfCamsPage;
